/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Delete_Share_ButtonInputs */

const en_team_share_delete_share_button = /** @type {(inputs: Team_Share_Delete_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Share`)
};

const fr_team_share_delete_share_button = /** @type {(inputs: Team_Share_Delete_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le partage`)
};

const de_team_share_delete_share_button = /** @type {(inputs: Team_Share_Delete_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen Teilen`)
};

const it_team_share_delete_share_button = /** @type {(inputs: Team_Share_Delete_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina Condividi`)
};

const ru_team_share_delete_share_button = /** @type {(inputs: Team_Share_Delete_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить Поделиться`)
};

const es_team_share_delete_share_button = /** @type {(inputs: Team_Share_Delete_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar Compartir`)
};

const zh_cn2_team_share_delete_share_button = /** @type {(inputs: Team_Share_Delete_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除共享`)
};

const ja_team_share_delete_share_button = /** @type {(inputs: Team_Share_Delete_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除 共有`)
};

const hi_team_share_delete_share_button = /** @type {(inputs: Team_Share_Delete_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शेयर हटाएं`)
};

const pt_pt2_team_share_delete_share_button = /** @type {(inputs: Team_Share_Delete_Share_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir Compartilhar`)
};

/**
* | output |
* | --- |
* | "Delete Share" |
*
* @param {Team_Share_Delete_Share_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_delete_share_button = /** @type {((inputs?: Team_Share_Delete_Share_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Delete_Share_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_delete_share_button(inputs)
	if (locale === "de") return de_team_share_delete_share_button(inputs)
	if (locale === "it") return it_team_share_delete_share_button(inputs)
	if (locale === "ru") return ru_team_share_delete_share_button(inputs)
	if (locale === "es") return es_team_share_delete_share_button(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_delete_share_button(inputs)
	if (locale === "ja") return ja_team_share_delete_share_button(inputs)
	if (locale === "hi") return hi_team_share_delete_share_button(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_delete_share_button(inputs)
	return en_team_share_delete_share_button(inputs)
});